// extracted by mini-css-extract-plugin
export default {"dropdown-list-item":"_targetPartnerList_dropdown-list-item__w7bO-","dropdown-no-padding":"_targetPartnerList_dropdown-no-padding__LZd5a"};